(function ($) {
    $(document).ready(function () {

        const section = $(".section-full_screen_hero_banner");

        $(window).on("load resize", () => {
            let footerHeight = $("footer").innerHeight() + 5;
            section.css({"height": `calc(100vh - ${footerHeight}px`});
        });

    })
})(jQuery);